import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LeftSection = styled.div`
  width: 50%;
  background: linear-gradient(90deg, #00419F 0%, #1562B7 50%, #1E90FF 100%);
  padding: 3rem;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;

  @media (max-width: 1024px) {
    width: 60%;
  }

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    height: auto;
    padding: 2rem 1rem;
  }
`;

const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ theme }) => theme.alignLogo || 'flex-start'};
  margin-bottom: 2rem;
  color: #fff;
  height: 120px;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
    height: auto;
    justify-content: center;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const LogoImage = styled.img`
  height: 150px;
  width: auto;
  max-width: 100%;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    height: 100px;
  }

  @media (max-width: 768px) {
    height: 80px;
  }
`;

const LeftContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -1rem;

  @media (max-width: 768px) {
    margin-top: 0;
    text-align: center;
  }
`;

const Title = styled.h1`
  font-size: 3.75rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 1.5rem;
  line-height: 1.1;

  @media (max-width: 1024px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const GradientText = styled.span`
  background: linear-gradient(to right, #4DA9FF, #B7E0FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const SubTitle = styled.p`
  font-size: 1.125rem;
  color: #d1d5db;
  max-width: 28rem;
  margin-bottom: 2rem;

  @media (max-width: 1024px) {
    max-width: 24rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    max-width: 100%;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const LearnMoreButton = styled(Link)`
  margin-top: 2rem;
  color: #fff;
  background-color: rgba(0, 87, 204, 0.5);
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  align-self: flex-start;
  text-decoration: none;

  &:hover {
    background-color: rgba(0, 87, 204, 0.7);
  }

  @media (max-width: 768px) {
    align-self: center;
    padding: 0.75rem 1.25rem;
  }

  @media (max-width: 480px) {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
`;

const ZDOLogo = '/zeroday-ops.png';

function LoginLeftSide() {
  return (
    <LeftSection>
      <LeftHeader>
        <LogoContainer>
          <LogoImage src={ZDOLogo} alt="Zeroday Ops Logo" />
        </LogoContainer>
      </LeftHeader>
      <LeftContent>
        <Title>
          Empower Your <br />
          <GradientText>Cybersecurity</GradientText> <br />
          Efforts with <br />
          Zeroday Ops
        </Title>
        <SubTitle>
          Our cutting-edge VAPT Scanner streamlines vulnerability assessments and penetration testing into one powerful platform. Stay ahead of evolving threats with real-time insights and prioritized fixes.
        </SubTitle>
        <LearnMoreButton to="https://www.zerodayops.com/">
          Learn more about Zeroday Ops →
        </LearnMoreButton>
      </LeftContent>
    </LeftSection>
  );
}

export default LoginLeftSide;
